import { useQuery } from '@tanstack/react-query';
import { LookupEntity } from 'pco-product-service-internal-consumer';
import { getEmployees } from 'services/portfolios/portfolioService';

const useGetEmployees = () => {
  return useQuery({
    queryKey: ['employees'],
    queryFn: getEmployees,
    select: (employees): LookupEntity[] =>
      employees.map(({ userId, firstName, lastName }) => ({
        key: userId,
        value: {
          code: userId,
          value: userId,
          label: [firstName, lastName].filter(Boolean).join(' ') || userId,
        },
      })),
  });
};

export default useGetEmployees;
